export const SIGN_IN = 'SIGN_IN'
export const SIGN_OUT = 'SIGN_OUT'
export const GET_POPULAR_MOVIE = 'GET_POPULAR_MOVIE'
export const GET_POPULAR_TV = 'GET_POPULAR_TV'
export const GET_TRENDING = 'GET_TRENDING'
export const SEARCH_MULTI = 'SEARCH_MULTI'
export const SEARCH_MOVIE_FILTER = 'SEARCH_MOVIE_FILTER'
export const GET_FILM = 'GET_FILM'
export const CLEAR_FILMDETAIL = 'CLEAR_FILMDETAIL'
export const GET_VOTING_MOVIE = 'GET_VOTING_MOVIE'
export const CREATE_NUMBER = 'CREATE_NUMBER'

export const GET_WISHLIST = 'GET_WISHLIST'
export const CLEAR_WISHLIST = 'CLEAR_WISHLIST'
export const ADD_WISH = 'ADD_WISH'
export const DELETE_WISH = 'DELETE_WISH'
export const UPDATE_WISHLIST = 'UPDATE_WISHLIST'
